/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import CodeableConceptEntry, { DisplayFromFHIRCodeableConcept, displayStringFromFHIRCodeableConcept } from "./CodeableConceptEntry";
import ReferenceEntry, { DisplayFromFHIRReference, displayStringFromFHIRReference } from "./ReferenceEntry";
import UCUM from "../dictionaries/UCUM";
import ExpandToAddOrEdit from "../components/ExpandToAddOrEdit";

const displayStringFromFHIRCodeableReference = (codeableReference) => {
  if (codeableReference === undefined || codeableReference === null || codeableReference === '') {
    return ""
  }
  if (typeof codeableReference === "object") {
    try {
      let codeableReferenceDisplay = "";
      if (codeableReference.concept) {
        codeableReferenceDisplay = displayStringFromFHIRCodeableConcept(codeableReference.concept);
      }
      if (codeableReferenceDisplay.reference) {
        if (codeableReferenceDisplay !== "") {
          codeableReferenceDisplay += ", ";
        }
        codeableReferenceDisplay += displayStringFromFHIRReference(codeableReference.reference);
      }
      if (codeableReferenceDisplay !== "") {
        return codeableReferenceDisplay;
      }
    } catch (e) { console.log(e); }
  }
  if (typeof codeableReference === "string") {
    return `${codeableReference} [ERROR: CodeableReference data not in expected CodeableReference datatype.]`
  }
  return "[ERROR: CodeableReference data not interpretable.]";
}

const DisplayFromFHIRCodeableReference = ({ codeableReference, containedResourceDictionary = {} }) => {
  if (codeableReference) {
    if (Array.isArray(codeableReference) || typeof codeableReference !== "object") {
      return <>[ERROR: CodeableReference data not interpretable.]</>;
    }
    if (codeableReference.concept && !codeableReference.reference) {
      return <DisplayFromFHIRCodeableConcept codeableConcept={codeableReference.concept} />
    }
    if (!codeableReference.concept && codeableReference.reference) {
      return <DisplayFromFHIRReference reference={codeableReference.reference}
        containedResourceJson={codeableReference.reference.reference && containedResourceDictionary[codeableReference.reference.reference]} />
    }
    if (codeableReference.concept && codeableReference.reference) {
      return <><DisplayFromFHIRCodeableConcept codeableConcept={codeableReference.concept} />; <DisplayFromFHIRReference reference={codeableReference.reference}
        containedResourceJson={codeableReference.reference.reference && containedResourceDictionary[codeableReference.reference.reference]} /></>
    }
  } else {
    return <></>
  }
}

const CodeableReferenceEntry = ({ elementName, fieldLabel, startingValue, setResourceState,
  allowedValues, valueSet, dataEntryStyle, inTableCell, debug, referencedResourceTypes,
  systemChoices, systemChoicesOpen, startCollapsed, enableCreation, containedResourceDictionary = {} }) => {

  if (dataEntryStyle === "Age") {
    valueSet = UCUM.age;
  } else if (dataEntryStyle === "Duration") {
    valueSet = UCUM.duration;
  } else if (valueSet === "UCUM") {
    valueSet = UCUM.common;
  }

  const [codeableReferenceState, setCodeableReferenceState] = useState({});
  const [startCollapsedState, setStartCollapsedState] = useState(startCollapsed);

  useEffect(() => {
    let startingCodeableReference = { "concept": "", "reference": "" };
    if (startingValue) {
      if (startingValue.extension) { startingCodeableReference.extension = startingValue.extension; }
      if (startingValue.concept) { startingCodeableReference.concept = startingValue.concept; }
      if (startingValue.reference) { startingCodeableReference.reference = startingValue.reference; }
    }
    setCodeableReferenceState(JSON.parse(JSON.stringify(startingCodeableReference)));
  }, []);

  useEffect((() => {
    if (Object.keys(codeableReferenceState).length) {
      let newCodeableReference = {};
      if (codeableReferenceState.extension) { newCodeableReference.extension = codeableReferenceState.extension; }
      if (codeableReferenceState.concept && Object.keys(codeableReferenceState.concept).length) { newCodeableReference.concept = codeableReferenceState.concept; }
      if (codeableReferenceState.reference && Object.keys(codeableReferenceState.reference).length) { newCodeableReference.reference = codeableReferenceState.reference; }
      if (Object.keys(newCodeableReference).length === 0) {
        newCodeableReference = null;
      }
      setResourceState(prevState => { return { ...prevState, [elementName]: newCodeableReference } });
    }
  }), [codeableReferenceState]);

  if (startCollapsedState) {
    return <>
      <div>
        <b>{fieldLabel}: </b>
        {startingValue && <DisplayFromFHIRCodeableReference codeableReference={startingValue}
          containedResourceDictionary={containedResourceDictionary} />}
        &nbsp;&nbsp;
        <ExpandToAddOrEdit startingValue={startingValue} setStartCollapsedState={setStartCollapsedState} />
      </div>
    </>
  } else if (Object.keys(codeableReferenceState).length > 0) {
    return <>
      <p style={{ marginBottom: "2px" }}><b>{fieldLabel}: </b></p>
      <div style={{ marginLeft: "24px" }}>
        <CodeableConceptEntry elementName='concept' fieldLabel='Concept'
          startingValue={codeableReferenceState.concept || null} setResourceState={setCodeableReferenceState}
          systemChoices={systemChoices} systemChoicesOpen={systemChoicesOpen}
          startCollapsed={startCollapsed}
          dataEntryStyle={dataEntryStyle} inTableCell={inTableCell} valueSet={valueSet} debug={debug} />
        <ReferenceEntry elementName='reference' fieldLabel='Reference'
          containedResourceDictionary={containedResourceDictionary}
          enableCreation={enableCreation} inTableCell={inTableCell} startCollapsed={startCollapsed}
          startingValue={codeableReferenceState.reference || null} setResourceState={setCodeableReferenceState}
          referencedResourceTypes={referencedResourceTypes} />
      </div>
    </>
  }
};

export default CodeableReferenceEntry;
export { DisplayFromFHIRCodeableReference, displayStringFromFHIRCodeableReference };